<app-intro>
  <app-lotto-box [lottoId]="lotto" system="wt" product="lottos" *ngIf="system === 'wt'"></app-lotto-box>
  <app-lotto-box [lottoId]="lotto" system="ltk" product="lottos" *ngIf="system === 'ltk'"></app-lotto-box>
</app-intro>
<app-nxnoffer></app-nxnoffer>
<app-how-to-play system="wt" *ngIf="system === 'wt'"></app-how-to-play>
<app-how-to-play system="ltk" *ngIf="system === 'ltk'"></app-how-to-play>
<app-what-is></app-what-is>
<app-about></app-about>
